import { axiosInstance } from "../axiosInstance";
const login = (data) => axiosInstance.post(`agency/login-post`, data)
const logout = (data) => axiosInstance.post(`agency/logout`, data)

export { login, logout }
